import React from "react";
import {
  Box,
  Typography,
  List,
  Paper,
  CircularProgress,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import ProductCheckoutView from "../../../../Components/Widgets/ProductCheckoutView";
import Translate from "../../../../../modules/Core/Components/Translate";
import SendIcon from "@mui/icons-material/Send";

const BRAND = "#f05d32";
const BRAND_HOVER = "#d94e27";

export default function SummarySection(props) {
  const { component } = props;
  const devHelper = component.getHelpers("dev");

  const { order = null } = component.getData("default", {});

  return (
    <>
      {order && (
        <Paper
          elevation={0}
          sx={{
            px: { xs: 2, md: 2.5 },
            py: { xs: 2, md: 2.5 },
            borderRadius: "16px",
            backgroundColor: "#fff",
            border: "1px solid rgba(0,0,0,0.06)",
            boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
          }}
        >
          <Box sx={{ width: "100%" }}>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: { xs: 18, sm: 20, md: 22 },
                lineHeight: 1.2,
                mb: 2,
                color: "#1a1a1a",
              }}
            >
              {component.ucfirst("checkout-title-4")}
            </Typography>

            {order && order.items.length !== 0 && (
              <Box>
                <List dense sx={{ width: "100%", py: 0 }}>
                  {order.items.map((product, index) => (
                    <ProductCheckoutView
                      key={index}
                      {...{
                        ...props,
                        ...{
                          product,
                        },
                      }}
                    />
                  ))}
                </List>

                <Box
                  sx={{
                    mt: 2,
                    pt: 2,
                    borderTop: "1px solid rgba(0,0,0,0.08)",
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: 15,
                      color: "#6b6b65",
                    }}
                  >
                    <span>{component.ucfirst("subtotal")}</span>
                    <span>
                      {component
                        .getApp()
                        .priceFormater(
                          devHelper.getObjectValue(order, "totals.items"),
                        )}
                    </span>
                  </Box>

                  {order.services
                    .filter((service) => service.selected)
                    .map((service) => (
                      <Box
                        key={devHelper.getObjectValue(service, "slug")}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: 15,
                          color: "#6b6b65",
                        }}
                      >
                        <span>
                          {component.ucfirst(
                            devHelper.getObjectValue(service, "slug"),
                          )}
                        </span>
                        <span>
                          {component
                            .getApp()
                            .priceFormater(
                              devHelper.getObjectValue(service, "price"),
                            )}
                        </span>
                      </Box>
                    ))}

                  {devHelper.getObjectValue(order, "totals.discount") ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: 15,
                        color: BRAND,
                        fontWeight: 500,
                      }}
                    >
                      <span>{component.ucfirst("discount")}</span>
                      <span>
                        -
                        {component
                          .getApp()
                          .priceFormater(
                            devHelper.getObjectValue(order, "totals.discount"),
                          )}
                      </span>
                    </Box>
                  ) : null}

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mt: 0.5,
                      pt: 1.5,
                      borderTop: "1px solid rgba(0,0,0,0.08)",
                      fontSize: 18,
                      fontWeight: 700,
                      color: "#1a1a1a",
                    }}
                  >
                    <span>{component.ucfirst("total")}</span>
                    <span>
                      {component
                        .getApp()
                        .priceFormater(
                          devHelper.getObjectValue(order, "totals.grand"),
                        )}
                    </span>
                  </Box>
                </Box>
              </Box>
            )}

            <Box
              component="form"
              onSubmit={(e) => component.complete(e)}
              sx={{ textAlign: "center", mt: 3 }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  mb: 2,
                  fontSize: 13,
                  color: "#6b6b65",
                  lineHeight: 1.45,
                }}
              >
                <Translate
                  entity="literal"
                  eslug="agree-privacy-policy-terms-checkbox"
                  scope="default"
                  slug="default"
                  auto
                />
              </Typography>
              <LoadingButton
                type="submit"
                fullWidth
                sx={{
                  py: 1.35,
                  bgcolor: BRAND,
                  borderRadius: "50px",
                  border: `1px solid ${BRAND}`,
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: 15,
                  textTransform: "none",
                  boxShadow: "0 2px 8px rgba(240, 93, 50, 0.25)",
                  "&:hover": {
                    bgcolor: BRAND_HOVER,
                    borderColor: BRAND_HOVER,
                    boxShadow: "0 4px 14px rgba(240, 93, 50, 0.35)",
                  },
                  "&:disabled": {
                    color: "#fff",
                    opacity: 0.8,
                  },
                }}
                endIcon={<SendIcon />}
                loadingPosition="end"
                loadingIndicator={
                  <CircularProgress size={16} sx={{ color: "#fff" }} />
                }
                loading={component.getData("default.preparing")}
              >
                {component.ucfirst("place-order-btn")}
              </LoadingButton>
            </Box>
          </Box>
        </Paper>
      )}
    </>
  );
}
